import { render, staticRenderFns } from "./ModalCodigosClinicos.vue?vue&type=template&id=5df532b6&scoped=true"
import script from "./ModalCodigosClinicos.vue?vue&type=script&lang=js"
export * from "./ModalCodigosClinicos.vue?vue&type=script&lang=js"
import style0 from "./ModalCodigosClinicos.vue?vue&type=style&index=0&id=5df532b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df532b6",
  null
  
)

export default component.exports